
// src/web/components/user-settings-page.jsx

import React from 'react'
import connect from '../../connects/user-settings-page.js'
import {
  SettingsPage,
  SettingsPanel,
  LinkPanel,
} from './settings-page'
import UserEmailPanel from './user-email-panel.jsx'
import UserPasswordPanel from './user-password-panel.jsx'
import UserFavoritesPanel from './user-favorites-panel'
import UserProfilePanel from './user-profile-panel.jsx'
import UserTemplatesPanel from './user-templates-panel.jsx'
import UserNotificationPanel from './user-notification-panel.jsx'
import TemplateFormPanel from './template-form-panel.jsx'
import UserLogoutPanel from './user-logout-panel.jsx'
import SortGroupsPage from './group-sorting-page.jsx'
import UserBlockPanel from './user-block-panel'
import UserExtensionsPanel from './user-extensions-panel.jsx'

class UserSettingsPage extends React.Component {
  render() {
    const {
      t,
      user,
      active,
      onClose,
      name,
      usersAdminUrl,
      blockUsers
    } = this.props

    return (
      <SettingsPage title={t('label:個人設定')}
          active={active}
          onCloseDialog={onClose}
          name={name}
          initialName="profile" >
        <SettingsPanel name="profile"
            label={t('label:プロフィール設定')}
            icon="person"
            component={UserProfilePanel} />
        <SettingsPanel name="favorite"
            label={t('label:お気に入り登録')}
            icon="flag"
            component={UserFavoritesPanel} />
        <SettingsPanel name="groupSorting"
            label={t('label:並べ替え')}
            icon="swap_vert"
            component={SortGroupsPage} />
        <SettingsPanel name="email"
            label={t('label:メールアドレス')}
            icon="email"
            component={UserEmailPanel} />
        <SettingsPanel name="password"
            label={t('label:パスワード変更')}
            icon="lock"
            component={UserPasswordPanel} />
        <SettingsPanel name="notification"
            label={t('label:通知設定')}
            icon="alarm"
            component={UserNotificationPanel} />
        <SettingsPanel name="templates"
            label={t('label:自分用テンプレート')}
            icon="edit"
            component={UserTemplatesPanel}
            subPanel={{
              new:  { component: TemplateFormPanel, label: t('label:新規作成') },
              edit: { component: TemplateFormPanel, label: t('label:編集') },
            }}/>
        <SettingsPanel name="extensions"
            label={t('label:拡張機能')}
            icon="extensions"
            component={UserExtensionsPanel} />
        {blockUsers && blockUsers.length > 0 && <SettingsPanel name="block"
            label={t('label:ブロックリスト')}
            icon="block"
            component={UserBlockPanel} />}
        {user && user.account_admin &&
          <LinkPanel
              label={t('label:アカウント管理')}
              icon="settings_applications"
              onClose={onClose}
              url={usersAdminUrl} />
        }
        <SettingsPanel name="logout"
            label={t('label:ログアウト')}
            icon="power_settings_new"
            component={UserLogoutPanel} />
      </SettingsPage>
    )
  }
}

export const RawUserSettingsPage = UserSettingsPage
export default connect(UserSettingsPage)



// WEBPACK FOOTER //
// ./src/web/components/user-settings-page.jsx